@use '../../scss/global' as *;
@use 'themes';

// ================================================================ //
// -- Local Variables

$wrapper-values: (
  lg: 2.725,
  xl: 3.5
);

// ================================================================ //
// -- Component Styles

:host {
  display: block;

  .fluid-file-upload {

    .file-upload-area {
      padding: var(--padding);
      border: var(--border);
      background-color: var(--background-color);
      color: var(--color);
      border-radius: var(--border-radius);
      margin-bottom: 1em;
    }

    .wrapper{
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 0.3em;
      min-height: 3.5em;

      @each $key, $value in $wrapper-values {
        &.wrapper-#{$key} {
          min-height: 3.5em + $value;

          @if $key == 'lg' {
            font-size: large;
          } @else if $key == 'xl' {
            font-size: x-large;
          }
        }
        &.wrapper-#{$key} .link-text {
          @if $key == 'lg' {
            font-size: large;
          } @else if $key == 'xl' {
            font-size: x-large;
          }
        }
      }
    }
  }
}
